const passwordInputs = document.querySelectorAll("[type='password']");

if (passwordInputs.length > 0) {
    const handleEyeClick = (input, eye) => {
        const type = input.getAttribute('type');

        if (type === 'password') {
            input.setAttribute('type', 'text');
            eye.classList.add('-shown');
        } else {
            input.setAttribute('type', 'password');
            eye.classList.remove('-shown');
        }
    };

    passwordInputs.forEach(input => {
        const eye = input.parentElement.querySelector('.form-input__eye-icon');
        if (!eye) return;
        eye.addEventListener('click', () => handleEyeClick(input, eye));
    });
}